const enGB = {
  navigation: {
    mydevice: "Mon appareil",
    mymobile: "Mon mobile"
  },
  photoorganiser: {
    navigation: {
      photos: "Photos",
      favorites: "Favoris",
      collections: "Albums",
      events: "Événements",
      latestuploads: "Dernières importations"
    },
    empty(source) {
      return "Vous n'avez pas de photos dans " + source
    }
  },
  mymobile: {
    title: "Récupérez les photos de votre mobile en un instant!",
    qrcode: {
      title: "Scannez le QR code",
      subtitle: "(Aucune application à installer)"
    },
    instruction: {
      title: "C'est parti!",
      step_1: "Ouvrez votre application Appareil Photo",
      step_2: "Scannez le QR code",
      step_3: "Suivez les instructions sur votre téléphone"
    }
  },
  layout: {
    flex: "Flexible",
    square: "Carré"
  },
  calender: {
    allmonths: "Tous les mois",
    allyears: "Toutes les années",
    months: {
      january: "Janvier",
      february: "Février",
      march: "Mars",
      april: "Avril",
      may: "Mai",
      june: "Juin",
      july: "Juillet",
      august: "Août",
      september: "Septembre",
      october: "Octobre",
      november: "Novembre",
      december: "Décembre"
    }
  },
  generic: {
    sortBy: "Trier par",
    selected: "Sélectionné",
    done: "Ajouter des photos",
    back: "Retour",
    images: "Photos",
    selection: "Sélection",
    date: "Date",
    name: "Nom",
    az: "Nom du fichier A-Z",
    za: "Nom du fichier Z-A",
    newestfirst: "Des plus récentes aux plus anciennes",
    oldestfirst: "Des plus anciennes aux plus récentes",
    photos: "Photos",
    all: "Tout",
    yes: "Oui",
    no: "Non",
    nodate: "Pas de date"
  },
  rangeText: {
    minMax(min, max) {
      return "Vous devez sélectionner " + min + " à " + max + " photos"
    },
    min(min) {
      return "Vous aurez besoin d'au moins " + min + " photos pour créer votre livre."
    },
    max(max) {
      return "Vous pouvez sélectionner " + max + "  photos maximum"
    }
  },
  addMorePhotos: "Ajouter plus de photos",
  upload: {
    browseButton: "Ajouter des photos",
    uploadlimit(maxSize) {
      return "La taille des images doit être inférieure à " + maxSize + "."
    },
    dragImage: "ou glissez et déposez vos photos directement ici.",
    errors: {
      GENERIC_ERROR:
        "Vous pouvez aussi faire glisser n'importe quel fichier image .jpg, .jpeg, ou .png ici. La taille des images doit être inférieure à x Mo.",
      EMPTY_FILE: "Référence d'image perdue, veuillez ajouter l'image de nouveau",
      MAX_FILE_SIZE: "La taille du fichier doit être inférieure à {0} Mo",
      UNSUPPORTED_FILE_TYPE: "Format du fichier non compatible",
      MAX_IMAGE_RESOLUTION: "La taille du fichier doit être inférieure à {0} pixels",
      INVALID_IMAGE: "Le fichier est endommagé"
    },
    errorSummary(number) {
      return "Impossible d'importer " + number + " fichiers"
    },
    errorDialog: {
      headline: "Oups !",
      ingress: "Les fichiers suivants n'ont pas pu être importés :",
      filenameColumn: "Fichier",
      reasonColumn: "Motif"
    },
    uploaded: "Importé",
    estimating: "Estimation de la durée",
    estimatedleft: "Estimation de la durée restante",
    ok: "OK",
    cancel: "Annuler",
    details: "Détails"
  }
}

export default enGB
